import type { AuthUser } from '@/lib/api';
import { canEdit } from '@/lib/api';
import {
  PendingSelfReportsSection,
  PlayerUsageSection,
} from '@/components/SelfReportAdmin';
import { RosterTabs } from './Roster';

export default function RosterSelfReports({ user }: { user: AuthUser }) {
  const editable = canEdit(user.role);

  return (
    <div className="space-y-4">
      <RosterTabs />
      <header>
        <h1 className="text-xl font-semibold">Self-Reports</h1>
        <p className="text-sm text-slate-400">
          Player-submitted strength values waiting for admin review.
        </p>
      </header>
      {!editable ? (
        <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-6 text-sm text-slate-400">
          R4/R5 required to manage self-reports.
        </div>
      ) : (
        <>
          <PendingSelfReportsSection />
          <PlayerUsageSection />
        </>
      )}
    </div>
  );
}
